export default "__VITE_ASSET__7d78d75b__"